module.exports = __webpack_public_path__ + "img/img21.6a636aae.svg";